import type { ModelType, ReasoningConfig } from "@/types";
import { ModelCapabilityFlags } from "./ModelCapabilityFlags";
import { ModelReasoningConfigFields } from "./ModelReasoningConfigFields";
import { ModelTypeSelect } from "./ModelTypeSelect";
import type { ModelCapabilityKey } from "./modelCapabilities";

export interface ModelBehaviorFieldsProps {
  idPrefix: string;
  modelType: ModelType;
  capabilities: Record<ModelCapabilityKey, boolean>;
  onModelTypeChange: (value: ModelType) => void;
  onCapabilityChange: (key: ModelCapabilityKey, checked: boolean) => void;
  reasoningConfig: ReasoningConfig | null;
  onReasoningConfigChange: (value: ReasoningConfig | null) => void;
}

/**
 * Model Type + behavioral capability flags + reasoning efforts, shared by
 * AddModelModal and ConfigureModelModal. Composes {@link ModelTypeSelect},
 * {@link ModelCapabilityFlags} and {@link ModelReasoningConfigFields}.
 */
export function ModelBehaviorFields({
  idPrefix,
  modelType,
  capabilities,
  onModelTypeChange,
  onCapabilityChange,
  reasoningConfig,
  onReasoningConfigChange,
}: Readonly<ModelBehaviorFieldsProps>) {
  return (
    <div className="space-y-4">
      <ModelTypeSelect idPrefix={idPrefix} value={modelType} onChange={onModelTypeChange} />
      <ModelCapabilityFlags idPrefix={idPrefix} values={capabilities} onChange={onCapabilityChange} />
      <ModelReasoningConfigFields
        idPrefix={idPrefix}
        enabled={capabilities.is_reasoning}
        value={reasoningConfig}
        onChange={onReasoningConfigChange}
      />
    </div>
  );
}
